import { render } from "./moduleGuide.vue?vue&type=template&id=7359cd1d"
import script from "./moduleGuide.vue?vue&type=script&lang=js"
export * from "./moduleGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__